import { create } from "zustand";

const useUserStore = create((set) => ({
	session: null,
	setSession: (session) => {
		if (session?.authenticated !== true || !session?.profile?.id || !session?.organization_id) {
			throw new TypeError("A session requires authentication, a user ID, and an organization ID.");
		}
		set({ session });
	},
	clearUser: () => set({ session: null }),
}));

export default useUserStore;
